Vue.component('mypostnl', {
    data() {
        return {
            uuid: "",

            zipCodeSearchTerm: '',
            zipCodeIsSearchOpen: false,
            zipCodeSearchResults: [],
            zipCodeQueryRunning: false,
            zipCodeTimer: null,
            zipCodeBlurTimer: null,

            citySearchTerm: '',
            cityIsSearchOpen: false,
            citySearchResults: [],
            cityQueryRunning: false,
            cityTimer: null,
            cityBlurTimer: null,
            cityReadOnly: true,
            cityDisabled: true,

            fullAddressSearchTerm: '',
            fullAddressIsSearchOpen: false,
            fullAddressSearchResults: [],
            fullAddressQueryRunning: false,
            fullAddressTimer: null,
            fullAddressBlurTimer: null,
            fullAddressReadOnly: true,
            fullAddressDisabled: true,

            houseNumberSearchTerm: '',
            houseNumberIsSearchOpen: false,
            houseNumberSearchResults: [],
            houseNumberQueryRunning: false,
            houseNumberTimer: null,
            houseNumberBlurTimer: null,

            houseNumberAdditionSearchTerm: '',
            houseNumberAdditionIsSearchOpen: false,
            houseNumberAdditionSearchResults: [],
            houseNumberAdditionQueryRunning: false,
            houseNumberAdditionTimer: null,
            houseNumberAdditionBlurTimer: null,
            houseNumberAdditionReadOnly: true,
            houseNumberAdditionDisabled: true,

            validateRunning: false,

            address: {},

            mapId: 'shop-map',
            map: null,
            marker: null,

            automatic: true,
            init: false

        };
    },
    props: ['defaultpostalcode', 'defaulthousenumber', 'defaulthousenumberaddition', 'defaultcity', 'defaultfulladdress',
        'postalcodeid', 'housenumberid', 'housenumberadditionid', 'streetid', 'cityid', 'fulladdressid', 'marketcountry', 'zipcodelength',
        'latitudeid', 'longitudeid'],
    mounted() {
        this.uuid = this.generateUUID();

        console.log(`postnl init ${this.uuid}`);

        if (this.fulladdressid != null && this.fulladdressid.length > 0) {

            this.zipCodeSearchTerm = this.RemoveSpaces(this.defaultpostalcode);
            this.houseNumberSearchTerm = this.defaulthousenumber;
            this.houseNumberAdditionSearchTerm = this.defaulthousenumberaddition;
            this.citySearchTerm = this.defaultcity;
            this.fullAddressSearchTerm = this.defaultfulladdress;

            if (this.automatic &&
                this.zipCodeSearchTerm.length === Number(this.zipcodelength)) {

                this.zipCodeFetchAutoComplete();
            }

            if (this.automatic &&
                this.zipCodeSearchTerm.length === Number(this.zipcodelength) &&
                this.citySearchTerm.length >= 2 &&
                this.fullAddressSearchTerm.length >= 5) {

                this.cityFetchAutoComplete();
                this.fullAddressFetchAutoComplete();
            }

        } else {

            this.zipCodeSearchTerm = this.RemoveSpaces(this.defaultpostalcode);
            this.houseNumberSearchTerm = this.defaulthousenumber;
            this.houseNumberAdditionSearchTerm = this.defaulthousenumberaddition;

            if (this.automatic &&
                this.zipCodeSearchTerm.length === Number(this.zipcodelength) && String(this.houseNumberSearchTerm).length >= 1) {
                this.zipCodeFetchAutoComplete();
                this.houseNumberFetchAutoComplete();
            }

            if (this.automatic &&
                this.zipCodeSearchTerm.length === Number(this.zipcodelength) && String(this.houseNumberSearchTerm).length >= 1 &&
                this.houseNumberAdditionSearchTerm.length > 0) {
                this.houseNumberAdditionFetchAutoComplete();
            }
        }

        document.addEventListener('click', this.handleClickOutside);

    },

    methods: {
        createMap(latLng) {
            const mapElement = document.getElementById(this.mapId);
            const options = {
                zoom: 18,
                minZoom: 7,
                maxZoom: 19,
                mapTypeControl: false,
                //fullscreenControl: false,
                streetViewControl: false,
                zoomControl: false,
                center: latLng,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapId: this.mapId
            };

            this.map = new google.maps.Map(mapElement, options);
        },
        createMarker(latLng) {

            this.marker = new google.maps.Marker({
                map: this.map,
                position: latLng
            });
        },

        generateUUID: () => {
            const url = URL.createObjectURL(new Blob())
            const [id] = url.toString().split('/').reverse()
            URL.revokeObjectURL(url)
            return id
        },

        handleClickOutside(e) {
            if (!e.target.classList.contains('form__search__input') && (e.target.closest('.faq__search__results') === null || !e.target.classList.contains('faq__search__results'))) {

                this.zipCodeReset();

                this.houseNumberReset();

                this.houseNumberAdditionReset();

                this.cityReset();

                this.fullAddressReset();



            }
        },
        sortShoplistByZipcode(e) {

            this.$emit('sortshoplist', e);
        },


        //----------------------------------------

        RemoveSpaces(val) {
            if (val) {
                return val.replace(/\s/g, '')
            }

            return val;
        },

        zipCodeReset() {
            //console.log('zip reset');

            if (this.zipCodeIsSearchOpen) {
                //this.zipCodeSearchResults = [];
                this.zipCodeIsSearchOpen = false;
            }
            //clearTimeout(this.zipCodeTimer);

        },

        zipCodeResetSearchTerm() {

            this.zipCodeSearchTerm = '';

        },

        zipCodeFocus(e) {

            if (!this.automatic) {
                return;
            }

            clearTimeout(this.zipCodeBlurTimer);

            this.houseNumberReset();

            this.houseNumberAdditionReset();

            this.cityReset();

            this.fullAddressReset();

            if (this.zipCodeSearchTerm.length === Number(this.zipcodelength)) {
                //this.zipCodeInputChanged();

                this.zipCodeFetchAutoComplete();
            }

        },

        zipCodeBlur(e) {

            if (!this.automatic) {
                return;
            }

            //console.log('blur');
            //console.log(e);

            if (this.zipCodeIsSearchOpen) {

                clearTimeout(this.zipCodeBlurTimer);

                this.zipCodeBlurTimer = setTimeout(() => {
                    this.zipCodeReset();
                }, 1000);
            }


            //clearTimeout(this.zipCodeTimer);

        },

        zipCodeInputChanged(event) {

            if (!this.automatic) {
                return;
            }

            //console.log('zipCodeInputChanged');

            clearTimeout(this.zipCodeBlurTimer);
            this.fullAddressQueryRunning = false;

            this.houseNumberResetSearchTerm();

            this.houseNumberAdditionResetSearchTerm();

            this.cityResetSearchTerm();

            this.fullAddressResetSearchTerm();

            if (this.zipCodeSearchTerm && this.zipCodeSearchTerm.indexOf(' ') !== -1) {
                this.zipCodeSearchTerm = this.RemoveSpaces(this.zipCodeSearchTerm);
            }

            if (this.zipCodeSearchTerm.length === Number(this.zipcodelength)) {

                if (!this.zipCodeQueryRunning) {
                    clearTimeout(this.zipCodeTimer);

                    this.zipCodeTimer = setTimeout(() => {

                        this.zipCodeFetchAutoComplete();
                    }
                        , 1000);
                }
                else {

                    clearTimeout(this.zipCodeTimer);

                    this.zipCodeTimer = setTimeout(() => {

                        this.zipCodeFetchAutoComplete();
                    }
                        , 1000);
                }

            } else {
                clearTimeout(this.zipCodeTimer);
                this.zipCodeIsSearchOpen = false;

                this.cityQueryRunning = false;
                this.validateRunning = false;
                this.zipCodeSearchResults = [];
                this.houseNumberSearchResults = [];
                this.houseNumberAdditionSearchResults = [];
                this.citySearchResults = [];
                this.fullAddressSearchResults = [];
                this.address = {};
                this.houseNumberResetSearchTerm();
                this.houseNumberAdditionResetSearchTerm();
                this.cityResetSearchTerm();
                this.fullAddressResetSearchTerm();
            }

            if (this.zipCodeSearchTerm.length !== Number(this.zipcodelength)) {

                this.citySearchTerm = '';
                this.cityReadOnly = true;
                this.cityDisabled = true;
                this.cityIsSearchOpen = false;

                this.fullAddressSearchTerm = '';
                this.fullAddressReadOnly = true;
                this.fullAddressDisabled = true;
                this.fullAddressIsSearchOpen = false;

                this.houseNumberAdditionSearchTerm = '';
                this.houseNumberAdditionReadOnly = true;
                this.houseNumberAdditionDisabled = true;
                this.houseNumberAdditionIsSearchOpen = false;

            }

        },
        zipCodeSelectResult(index) {

            //console.log(this.zipCodeSearchResults[index]);

            this.houseNumberResetSearchTerm();

            this.houseNumberAdditionResetSearchTerm();

            this.cityResetSearchTerm();

            this.fullAddressResetSearchTerm();

            this.zipCodeSearchTerm = this.zipCodeSearchResults[index];
            this.zipCodeIsSearchOpen = false;
            this.zipCodeSearchResults = [];
            this.zipCodeSearchResults.push(this.zipCodeSearchTerm);

            //document.getElementById(this.postalcodeid).focus();

            if (this.fulladdressid != null && this.fulladdressid.length > 0) {
                this.cityFetchAutoComplete();

            } else {
                this.validate(1);
            }

        },
        zipCodeFetchAutoComplete() {

            //console.log("zip fetch");

            this.zipCodeSearchResults = [];
            this.zipCodeQueryRunning = true;

            if (document.activeElement === document.getElementById(this.postalcodeid)) {
                this.zipCodeIsSearchOpen = true;
                this.init = true;
            }

            fetch(encodeURI(`/api/postnl/zipcodelist?uuid=${this.uuid}&zipcode=${this.zipCodeSearchTerm}`), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': document.documentElement.lang,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'same-origin'
            }).then(response => response.json()).then((autocompleteResponse) => {

                this.zipCodeSearchResults = autocompleteResponse;

                if (this.zipCodeSearchResults.length === 1) {
                    this.zipCodeIsSearchOpen = false;
                }

                this.zipCodeQueryRunning = false;

                if (this.fulladdressid != null && this.fulladdressid.length > 0) {
                    this.cityFetchAutoComplete();
                } else {
                    this.validate(2);
                }

            });
        },


        //----------------------------------------

        cityReset() {
            //console.log('city reset');

            if (this.cityIsSearchOpen) {
                //this.citySearchResults = [];
                this.cityIsSearchOpen = false;
            }
            //clearTimeout(this.cityTimer);

        },

        cityResetSearchTerm() {

            this.citySearchTerm = '';

        },

        cityFocus(e) {

            if (!this.automatic) {
                return;
            }

            if (this.cityReadOnly === true) {
                return;
            }

            clearTimeout(this.cityBlurTimer);

            this.houseNumberReset();

            this.houseNumberAdditionReset();

            this.fullAddressReset();


            if (this.zipCodeSearchTerm.length === Number(this.zipcodelength)) {
                //this.cityInputChanged();

                this.cityFetchAutoComplete();
            }

        },

        cityBlur(e) {

            if (!this.automatic) {
                return;
            }

            if (this.cityReadOnly === true) {
                return;
            }

            //console.log('blur');
            //console.log(e);

            if (this.cityIsSearchOpen) {

                clearTimeout(this.cityBlurTimer);

                this.cityBlurTimer = setTimeout(() => {
                    this.cityReset();
                }, 1000);
            }


            //clearTimeout(this.cityTimer);

        },

        cityInputChanged(event) {

            if (!this.automatic) {
                return;
            }

            //console.log('cityInputChanged');

            clearTimeout(this.cityBlurTimer);
            this.fullAddressQueryRunning = false;

            this.houseNumberResetSearchTerm();

            this.houseNumberAdditionResetSearchTerm();

            this.fullAddressResetSearchTerm();

            if (!this.cityQueryRunning) {
                clearTimeout(this.cityTimer);

                this.cityTimer = setTimeout(() => {

                    this.cityFetchAutoComplete();
                }
                    , 1000);
            }
            else {

                clearTimeout(this.cityTimer);

                this.cityTimer = setTimeout(() => {

                    this.cityFetchAutoComplete();
                }
                    , 1000);
            }

        },
        citySelectResult(index) {

            //console.log(this.citySearchResults[index]);

            this.houseNumberResetSearchTerm();

            this.houseNumberAdditionResetSearchTerm();

            this.fullAddressResetSearchTerm();

            this.citySearchTerm = this.citySearchResults[index];
            this.cityIsSearchOpen = false;
            this.citySearchResults = [];
            this.citySearchResults.push(this.citySearchTerm);

            this.fullAddressReadOnly = false;
            this.fullAddressDisabled = false;

            //document.getElementById(this.cityid).focus();

            this.validate(3);

        },
        cityFetchAutoComplete() {

            //console.log("city fetch");

            this.citySearchResults = [];

            if (this.zipCodeSearchTerm.length !== Number(this.zipcodelength)) {

                this.cityResetSearchTerm();
                this.cityReadOnly = true;
                this.cityDisabled = true;

                this.fullAddressResetSearchTerm();
                this.fullAddressReadOnly = true;
                this.fullAddressDisabled = true;

                this.houseNumberAdditionResetSearchTerm();
                this.houseNumberAdditionReadOnly = true;
                this.houseNumberAdditionDisabled = true;

                return;
            }

            this.cityQueryRunning = true;

            if (document.activeElement === document.getElementById(this.cityid)) {
                this.cityIsSearchOpen = true;
                this.init = true;
            }

            fetch(encodeURI(`/api/postnl/citylist?uuid=${this.uuid}&zipcode=${this.zipCodeSearchTerm}&city=${this.citySearchTerm}`), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': document.documentElement.lang,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'same-origin'
            }).then(response => response.json()).then((autocompleteResponse) => {

                if (this.cityQueryRunning === true) {

                    this.citySearchResults = autocompleteResponse;

                    if (this.citySearchResults.length === 1) {

                        this.citySearchTerm = autocompleteResponse[0];

                        this.cityReadOnly = false;
                        this.cityDisabled = false;

                        this.fullAddressReadOnly = false;
                        this.fullAddressDisabled = false;

                        this.cityIsSearchOpen = false;
                    } else {
                        this.cityReadOnly = false;
                        this.cityDisabled = false;

                        this.fullAddressReadOnly = true;
                        this.fullAddressDisabled = true;

                        this.houseNumberAdditionReadOnly = true;
                        this.houseNumberAdditionDisabled = true;

                    }

                    this.cityQueryRunning = false;

                    this.validate(4);

                    /*
    
                    if (this.citySearchResults.length >= 1 && (this.address === null)) {
                        this.cityReadOnly = false;
                        this.cityDisabled = false;
    
                        if (document.activeElement === document.getElementById(this.cityid)) {
                            this.cityIsSearchOpen = true;
                        }
    
                        */

                }

            });
        },

        //----------------------------------------

        fullAddressReset() {
            //console.log('fullAddress reset');

            if (this.fullAddressIsSearchOpen) {
                //this.fullAddressSearchResults = [];
                this.fullAddressIsSearchOpen = false;
            }
            //clearTimeout(this.fullAddressTimer);

        },

        fullAddressResetSearchTerm() {

            this.fullAddressSearchTerm = '';

        },

        fullAddressFocus(e) {

            if (!this.automatic) {
                return;
            }

            if (this.fullAddressReadOnly === true) {
                return;
            }

            clearTimeout(this.fullAddressBlurTimer);

            this.houseNumberReset();

            this.houseNumberAdditionReset();

            this.cityReset();

            if (this.zipCodeSearchTerm.length === Number(this.zipcodelength) &&
                this.fullAddressSearchTerm.length >= 5) {
                //this.fullAddressInputChanged();

                this.fullAddressFetchAutoComplete();
            }

        },

        fullAddressBlur(e) {

            if (!this.automatic) {
                return;
            }

            if (this.fullAddressReadOnly === true) {
                return;
            }

            //console.log('blur');
            //console.log(e);

            if (this.fullAddressIsSearchOpen) {

                clearTimeout(this.fullAddressBlurTimer);

                this.fullAddressBlurTimer = setTimeout(() => {
                    this.fullAddressReset();
                }, 1000);
            }


            //clearTimeout(this.fullAddressTimer);

        },

        fullAddressInputChanged(event) {

            if (!this.automatic) {
                return;
            }

            //console.log('fullAddressInputChanged');

            clearTimeout(this.fullAddressBlurTimer);
            this.fullAddressQueryRunning = false;

            this.houseNumberResetSearchTerm();

            this.houseNumberAdditionResetSearchTerm();

            if (this.fullAddressSearchTerm.length >= 5) {

                if (!this.fullAddressQueryRunning) {
                    clearTimeout(this.fullAddressTimer);

                    this.fullAddressTimer = setTimeout(() => {

                        this.fullAddressFetchAutoComplete();
                    }
                        , 1000);
                }
                else {

                    clearTimeout(this.fullAddressTimer);

                    this.fullAddressTimer = setTimeout(() => {

                        this.fullAddressFetchAutoComplete();
                    }
                        , 1000);
                }
            }

        },
        fullAddressSelectResult(index) {

            //console.log(this.fullAddressSearchResults[index]);

            this.houseNumberResetSearchTerm();

            this.houseNumberAdditionResetSearchTerm();

            this.fullAddressSearchTerm = this.fullAddressSearchResults[index];
            this.fullAddressIsSearchOpen = false;
            this.fullAddressSearchResults = [];
            this.fullAddressSearchResults.push(this.fullAddressSearchTerm);

            //document.getElementById(this.fulladdressid).focus();

            this.validate(5);

        },
        fullAddressFetchAutoComplete() {

            //console.log("full address fetch");

            this.fullAddressSearchResults = [];
            this.fullAddressQueryRunning = true;

            if (document.activeElement === document.getElementById(this.fulladdressid)) {
                this.fullAddressIsSearchOpen = true;
                this.init = true;
            }

            fetch(encodeURI(`/api/postnl/fulladdresslist?uuid=${this.uuid}&zipcode=${this.zipCodeSearchTerm}&city=${this.citySearchTerm}&address=${this.fullAddressSearchTerm}`), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': document.documentElement.lang,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'same-origin'
            }).then(response => response.json()).then((autocompleteResponse) => {

                this.fullAddressSearchResults = autocompleteResponse;

                if (this.fullAddressSearchResults.length === 1) {

                    this.fullAddressSearchTerm = autocompleteResponse[0];

                    this.fullAddressReadOnly = (this.fullAddressSearchTerm === '');
                    this.fullAddressDisabled = (this.fullAddressSearchTerm === '');

                    this.fullAddressIsSearchOpen = false;

                    this.houseNumberAdditionIsSearchOpen = false;

                } else {
                    this.fullAddressReadOnly = false;
                    this.fullAddressDisabled = false;
                }

                this.fullAddressQueryRunning = false;

                this.validate(6);

                /*
                if (this.fullAddressSearchResults.length >= 1 && (this.address === null)) {
                    this.fullAddressReadOnly = false;
                    this.fullAddressDisabled = false;

                    if (document.activeElement === document.getElementById(this.fulladdressid)) {
                        this.fullAddressIsSearchOpen = true;
                    }

                    */


            });
        },

        //---------------------------------------------------

        houseNumberReset() {

            //console.log('house reset');

            if (this.houseNumberIsSearchOpen) {

                //this.houseNumberSearchResults = [];
                this.houseNumberIsSearchOpen = false;

            }
            //clearTimeout(this.houseNumberTimer);

        },

        houseNumberResetSearchTerm() {

            this.houseNumberSearchTerm = '';

        },

        houseNumberFocus(e) {

            if (!this.automatic) {
                return;
            }

            clearTimeout(this.houseNumberBlurTimer);

            this.zipCodeReset();
            this.houseNumberAdditionReset();

            if (this.zipCodeSearchTerm.length === Number(this.zipcodelength)) {
                //this.houseNumberInputChanged();

                this.houseNumberFetchAutoComplete();
            }

        },

        houseNumberBlur(e) {

            if (!this.automatic) {
                return;
            }

            //console.log('blur');
            //console.log(e);

            if (this.houseNumberIsSearchOpen) {

                clearTimeout(this.houseNumberBlurTimer);

                this.houseNumberBlurTimer = setTimeout(() => {
                    this.houseNumberReset();
                }, 1000);
            }


            //clearTimeout(this.houseNumberTimer);

        },

        houseNumberInputChanged(event) {

            if (!this.automatic) {
                return;
            }

            //console.log('houseNumberInputChanged');

            clearTimeout(this.houseNumberBlurTimer);
            this.fullAddressQueryRunning = false;

            this.houseNumberAdditionResetSearchTerm();

            if (!this.houseNumberQueryRunning) {
                clearTimeout(this.houseNumberTimer);

                this.houseNumberTimer = setTimeout(() => {

                    this.houseNumberFetchAutoComplete();
                }
                    , 1000);
            }
            else {

                clearTimeout(this.houseNumberTimer);

                this.houseNumberTimer = setTimeout(() => {

                    this.houseNumberFetchAutoComplete();
                }
                    , 1000);
            }

        },
        houseNumberSelectResult(index) {

            //console.log(this.houseNumberSearchResults[index]);

            this.houseNumberAdditionResetSearchTerm();

            this.houseNumberSearchTerm = this.houseNumberSearchResults[index];
            this.houseNumberIsSearchOpen = false;
            this.houseNumberSearchResults = [];
            this.houseNumberSearchResults.push(this.houseNumberSearchTerm);

            //document.getElementById(this.housenumberid).focus();

            this.validate(7);

        },
        houseNumberFetchAutoComplete() {
            this.houseNumberSearchResults = [];
            this.houseNumberQueryRunning = true;

            if (document.activeElement === document.getElementById(this.housenumberid)) {
                this.houseNumberIsSearchOpen = true;
                this.init = true;
            }

            fetch(encodeURI(`/api/postnl/housenumberlist?uuid=${this.uuid}&zipcode=${this.zipCodeSearchTerm}&housenumber=${this.houseNumberSearchTerm}`), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': document.documentElement.lang,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'same-origin'
            }).then(response => response.json()).then((autocompleteResponse) => {

                this.houseNumberSearchResults = autocompleteResponse;

                if (this.houseNumberSearchResults.length === 1) {
                    this.houseNumberIsSearchOpen = false;
                    this.houseNumberSearchTerm = autocompleteResponse[0];
                }

                this.houseNumberQueryRunning = false;

                this.validate(8);

            });
        },

        //---------------------------------------------------

        houseNumberAdditionReset() {

            //console.log('house add reset');

            if (this.houseNumberAdditionIsSearchOpen) {

                //this.houseNumberAdditionSearchResults = [];
                this.houseNumberAdditionIsSearchOpen = false;

            }
            //clearTimeout(this.houseNumberAdditionTimer);

        },

        houseNumberAdditionResetSearchTerm() {

            this.houseNumberAdditionSearchTerm = '';

        },

        houseNumberAdditionFocus(e) {

            if (!this.automatic) {
                return;
            }

            if (this.houseNumberAdditionReadOnly === true) {
                return;
            }

            clearTimeout(this.houseNumberAdditionBlurTimer);

            this.zipCodeReset()
            this.houseNumberReset();


            if (this.zipCodeSearchTerm.length === Number(this.zipcodelength) && String(this.houseNumberSearchTerm).length > 0) {
                //this.houseNumberAdditionInputChanged();
                this.houseNumberAdditionFetchAutoComplete();
            }

        },

        houseNumberAdditionBlur(e) {

            if (!this.automatic) {
                return;
            }

            if (this.houseNumberAdditionReadOnly === true) {
                return;
            }

            //console.log(e);

            if (this.houseNumberAdditionIsSearchOpen) {

                clearTimeout(this.houseNumberAdditionBlurTimer);

                this.houseNumberAdditionBlurTimer = setTimeout(() => {
                    this.houseNumberAdditionReset();
                }, 1000);
            }

            //clearTimeout(this.houseNumberAdditionTimer);

        },

        houseNumberAdditionInputChanged() {

            if (!this.automatic) {
                return;
            }

            //console.log('houseNumberAdditionInputChanged');

            clearTimeout(this.houseNumberAdditionBlurTimer);
            this.fullAddressQueryRunning = false;

            if (!this.houseNumberAdditionQueryRunning) {
                clearTimeout(this.houseNumberAdditionTimer);

                this.houseNumberAdditionTimer = setTimeout(() => {

                    this.houseNumberAdditionFetchAutoComplete();
                }
                    , 1000);
            }
            else {

                clearTimeout(this.houseNumberAdditionTimer);

                this.houseNumberAdditionTimer = setTimeout(() => {

                    this.houseNumberAdditionFetchAutoComplete();
                }
                    , 1000);
            }

        },
        houseNumberAdditionSelectResult(index) {

            //console.log(this.houseNumberAdditionSearchResults[index]);

            this.houseNumberAdditionSearchTerm = this.houseNumberAdditionSearchResults[index];
            this.houseNumberAdditionIsSearchOpen = false;
            this.houseNumberAdditionSearchResults = [];
            this.houseNumberAdditionSearchResults.push(this.houseNumberAdditionSearchTerm);

            //document.getElementById(this.housenumberadditionid).focus();

            this.validate(9);

        },

        checkAnyHouseNumberAddition() {

            if (this.zipCodeSearchTerm.length === Number(this.zipcodelength) && this.zipCodeSearchResults.length === 1 &&
                String(this.houseNumberSearchTerm).length >= 1 && this.houseNumberSearchResults.length > 0 && this.houseNumberSearchResults.includes(String(this.houseNumberSearchTerm))) {

                fetch(encodeURI(`/api/postnl/housenumberadditionlist?uuid=${this.uuid}&zipcode=${this.zipCodeSearchTerm}&housenumber=${this.houseNumberSearchTerm}&addition=${this.houseNumberAdditionSearchTerm}`), {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': document.documentElement.lang,
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin'
                }).then(response => response.json()).then((autocompleteResponse) => {

                    this.houseNumberAdditionSearchResults = autocompleteResponse;

                    if (autocompleteResponse.length === 1) {

                        this.houseNumberAdditionSearchTerm = autocompleteResponse[0];

                        this.houseNumberAdditionReadOnly = (this.houseNumberAdditionSearchTerm === '');
                        this.houseNumberAdditionDisabled = (this.houseNumberAdditionSearchTerm === '');

                        this.houseNumberAdditionIsSearchOpen = false;

                        this.validate(11);
                    } else {
                        this.houseNumberAdditionReadOnly = false;
                        this.houseNumberAdditionDisabled = false;
                    }

                    if (this.houseNumberAdditionSearchResults.length >= 1 && (this.address === null)) {
                        this.houseNumberAdditionReadOnly = false;
                        this.houseNumberAdditionDisabled = false;

                        if (document.activeElement === document.getElementById(this.housenumberadditionid)) {
                            this.houseNumberAdditionIsSearchOpen = true;
                        }

                        //document.getElementById(this.housenumberadditionid).focus();
                    }

                });

            } else {
                this.houseNumberAdditionSearchTerm = '';
                this.houseNumberAdditionReadOnly = true;
                this.houseNumberAdditionDisabled = true;
                this.houseNumberAdditionIsSearchOpen = false;
            }
        },

        houseNumberAdditionFetchAutoComplete() {
            this.houseNumberAdditionSearchResults = [];
            this.houseNumberAdditionQueryRunning = true;

            if (document.activeElement === document.getElementById(this.housenumberadditionid)) {
                this.houseNumberAdditionIsSearchOpen = true;
                this.init = true;
            }

            fetch(encodeURI(`/api/postnl/housenumberadditionlist?uuid=${this.uuid}&zipcode=${this.zipCodeSearchTerm}&housenumber=${this.houseNumberSearchTerm}&addition=${this.houseNumberAdditionSearchTerm}`), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': document.documentElement.lang,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'same-origin'
            }).then(response => response.json()).then((autocompleteResponse) => {

                this.houseNumberAdditionSearchResults = autocompleteResponse;

                if (this.houseNumberAdditionSearchResults.length === 1) {
                    this.houseNumberAdditionIsSearchOpen = false;
                }

                this.houseNumberAdditionQueryRunning = false;

                this.validate(10);
            });
        },

        //-------------------------------------------


        validate(srcindex) {

            if (this.fulladdressid != null && this.fulladdressid.length > 0) {

                if (this.zipCodeSearchResults.length === 1 && this.zipCodeSearchTerm.length === Number(this.zipcodelength) &&
                    this.citySearchResults.length >= 1 && this.citySearchTerm.length >= 2 &&
                    this.fullAddressSearchResults.length >= 1 && this.fullAddressSearchTerm.length >= 5
                ) {

                    this.validateRunning = true;
                    fetch(encodeURI(`/api/postnl/validate?uuid=${this.uuid}&zipcode=${this.zipCodeSearchTerm}&city=${this.citySearchTerm}&fulladdress=${this.fullAddressSearchTerm}`), {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': document.documentElement.lang,
                            'X-Requested-With': 'XMLHttpRequest'
                        },
                        credentials: 'same-origin'
                    }).then(response => response.json()).then((autocompleteResponse) => {

                        if (this.validateRunning === true) {

                            this.address = autocompleteResponse;

                            if (this.address != null && this.address.address1 != null && this.address.address1.length > 1 && this.address.mailabilityScore === 100) {

                                if (document.activeElement !== document.getElementById(this.postalcodeid)) {
                                    this.zipCodeSearchTerm = this.address.postalCode;
                                }

                                document.getElementById(this.streetid).value = this.address.streetName;
                                document.getElementById(this.housenumberid).value = this.address.houseNumber;

                                if (this.marketcountry !== 'FR') {
                                    document.getElementById(this.housenumberadditionid).value = this.address.houseNumberAddition;
                                }

                                this.houseNumberAdditionReadOnly = false;
                                this.houseNumberAdditionDisabled = false;

                                this.fullAddressSearchTerm = this.address.address1;

                                /*
                                if (this.address.latitude != null && this.address.longitude != null) {
        
                                    var latLng = new google.maps.LatLng(this.address.latitude, this.address.longitude);
        
                                    if (!this.map) {
                                        this.createMap(latLng);
                                    } else {
        
                                        this.map.setZoom(18);
        
                                        this.map.setCenter(latLng);
                                    }
        
                                    if (!this.marker) {
                                        this.createMarker(latLng)
                                    } else {
                                        this.marker.setPosition(latLng);
                                    }
        
                                }*/
                                //});


                            } else {
                                document.getElementById(this.streetid).value = '';
                                document.getElementById(this.housenumberid).value = '';

                                if (this.marketcountry !== 'FR') {
                                    document.getElementById(this.housenumberadditionid).value = '';
                                }

                                //this.houseNumberAdditionSearchTerm = '';
                                this.houseNumberAdditionReadOnly = true;
                                this.houseNumberAdditionDisabled = true;
                                this.houseNumberAdditionIsSearchOpen = false;

                                if (srcindex === 5) {
                                    document.getElementById(this.fulladdressid).focus();
                                }

                            }

                        }

                        this.init = true;

                        Vue.nextTick(() => {
                            this.validateRunning = false;
                        });
                    });
                }
                else {
                    this.address = {};
                    document.getElementById(this.streetid).value = '';
                    document.getElementById(this.housenumberid).value = '';
                    document.getElementById(this.housenumberadditionid).value = '';

                    if (this.zipCodeSearchResults.length < 1) {
                        //this.citySearchTerm = '';
                        this.cityReadOnly = true;
                        this.cityDisabled = true;
                        this.cityIsSearchOpen = false;
                    }

                    if (this.citySearchResults.length < 1 && this.citySearchTerm.length >= 2) {
                        //this.fullAddressSearchTerm = '';
                        this.fullAddressReadOnly = true;
                        this.fullAddressDisabled = true;
                        this.fullAddressIsSearchOpen = false;
                    }

                    //this.houseNumberAdditionSearchTerm = '';
                    this.houseNumberAdditionReadOnly = true;
                    this.houseNumberAdditionDisabled = true;
                    this.houseNumberAdditionIsSearchOpen = false;

                }

            }
            else {

                if (this.zipCodeSearchResults.length === 1 && this.zipCodeSearchTerm.length === Number(this.zipcodelength) &&
                    this.houseNumberSearchResults.length > 0 && String(this.houseNumberSearchTerm).length >= 1) {

                    this.validateRunning = true;

                    //console.log(`/api/postnl/validate?uuid=${this.uuid}&zipcode=${this.zipCodeSearchTerm}&housenumber=${this.houseNumberSearchTerm}&addition=${this.houseNumberAdditionSearchTerm}`);

                    fetch(encodeURI(`/api/postnl/validate?uuid=${this.uuid}&zipcode=${this.zipCodeSearchTerm}&housenumber=${this.houseNumberSearchTerm}&addition=${this.houseNumberAdditionSearchTerm}`), {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': document.documentElement.lang,
                            'X-Requested-With': 'XMLHttpRequest'
                        },
                        credentials: 'same-origin'
                    }).then(response => response.json()).then((autocompleteResponse) => {

                        if (this.validateRunning === true) {

                            this.address = autocompleteResponse;

                            if (srcindex !== 11) {
                                this.checkAnyHouseNumberAddition();
                            }

                            if (this.address != null && this.address.address1 != null && this.address.address1.length > 1 && this.address.mailabilityScore === 100) {

                                if (document.activeElement !== document.getElementById(this.postalcodeid)) {
                                    this.zipCodeSearchTerm = this.address.postalCode;
                                }

                                if (document.activeElement !== document.getElementById(this.housenumberid)) {
                                    this.houseNumberSearchTerm = this.address.houseNumber;
                                }

                                if (document.activeElement !== document.getElementById(this.housenumberadditionid)) {
                                    this.houseNumberAdditionSearchTerm = this.address.houseNumberAddition;
                                }

                                document.getElementById(this.streetid).value = this.address.streetName;
                                document.getElementById(this.cityid).value = this.address.cityName;

                                if (this.latitudeid !== null && document.getElementById(this.latitudeid) !== null) {
                                    document.getElementById(this.latitudeid).value = this.address.latitude;
                                }
                                if (this.longitudeid !== null && document.getElementById(this.longitudeid) !== null) {
                                    document.getElementById(this.longitudeid).value = this.address.longitude;
                                }

                                /*
                                if (this.address.latitude != null && this.address.longitude != null) {
        
                                    var latLng = new google.maps.LatLng(this.address.latitude, this.address.longitude);
        
                                    if (!this.map) {
                                        this.createMap(latLng);
                                    } else {
        
                                        this.map.setZoom(18);
        
                                        this.map.setCenter(latLng);
                                    }
        
                                    if (!this.marker) {
                                        this.createMarker(latLng)
                                    } else {
                                        this.marker.setPosition(latLng);
                                    }
        
                                }*/
                                //});


                            } else {
                                document.getElementById(this.streetid).value = '';
                                document.getElementById(this.cityid).value = '';

                                if (this.latitudeid && document.getElementById(this.latitudeid)) {
                                    document.getElementById(this.latitudeid).value = '';
                                }
                                if (this.longitudeid && document.getElementById(this.longitudeid)) {
                                    document.getElementById(this.longitudeid).value = '';
                                }

                                //this.houseNumberAdditionReadOnly = true;
                                //this.houseNumberAdditionDisabled = true;
                                //this.houseNumberAdditionIsSearchOpen = false;
                            }

                        }

                        this.init = true;

                        Vue.nextTick(() => {
                            this.validateRunning = false;
                        });
                    });
                }
                else {
                    this.address = {};
                    document.getElementById(this.streetid).value = '';
                    document.getElementById(this.cityid).value = '';

                    if (this.latitudeid && document.getElementById(this.latitudeid)) {
                        document.getElementById(this.latitudeid).value = '';
                    }
                    if (this.longitudeid && document.getElementById(this.longitudeid)) {
                        document.getElementById(this.longitudeid).value = '';
                    }

                    this.houseNumberAdditionReadOnly = true;
                    this.houseNumberAdditionDisabled = true;
                    this.houseNumberAdditionIsSearchOpen = false;

                }

            }
        },

    }
});
